/* import __COLOCATED_TEMPLATE__ from './trending-topic-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { TrendingTopic } from 'embercom/components/reporting/automation/fin-ai-agent/analyze/topic-trends/trending-topics-data-resources';

interface Args {
  trendingTopic: TrendingTopic;
  onShowConversationExplorer: (topic: TrendingTopic) => void;
}

export default class TrendingTopicCard extends Component<Args> {
  @action
  onShowConversationExplorer(topic: TrendingTopic) {
    this.args.onShowConversationExplorer(topic);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TrendingTopicCard': typeof TrendingTopicCard;
  }
}
